/*
SLB GENERATED FILE — DO NOT EDIT
Project: Saam Law BaseStation (SLB)
Build-Version: SLB_V4_133_JEE_CHAT_TRANSACTION_CONSOLE_20260910_01
Output: assets/slb.qc.js
Source: slb_src/slices/qc/
Build: manual patch (Phase 1)
Built: 2026-02-11
*/

window.__SLB_QC_BUILD_TAG__ = 'SLB_SECURE_POST_P52_HARDENED_V105_20260720_01';
try{var __bf=document.getElementById('slbBuildFoot');if(__bf)__bf.textContent=String(window.__SLB_QC_BUILD_TAG__||'').trim()||__bf.textContent;}catch(_e){}

(function(){
  function $(id){ return document.getElementById(id); }
  function nowIso(){ try{ return new Date().toISOString(); }catch(e){ return ""; } }
  function safeGet(fn, fallback){ try{ return fn(); }catch(e){ return fallback; } }

  function setText(id, txt){ var el = $(id); if(el) el.textContent = (txt==null?"":String(txt)); }
  function esc(s){ return String(s||"").replace(/[&<>"]/g, function(c){ return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]); }); }

  function mkRow(t){
    var row = document.createElement("div");
    row.className = "slbQcRow";
    row.innerHTML =
      '<div class="slbQcRowTop">' +
        '<div class="slbQcName">'+esc(t.name)+'</div>' +
        '<div class="slbQcPill slbQcPill--pending">PENDING</div>' +
      '</div>' +
      '<div class="slbQcDetail" style="display:none"></div>';
    return row;
  }
  function setRow(row, state, detail){
    var pill = row.querySelector(".slbQcPill");
    var det = row.querySelector(".slbQcDetail");
    pill.classList.remove("slbQcPill--pending","slbQcPill--pass","slbQcPill--fail");
    if(state==="PASS"){
      pill.classList.add("slbQcPill--pass");
      pill.textContent = "PASS";
    }else if(state==="FAIL"){
      pill.classList.add("slbQcPill--fail");
      pill.textContent = "FAIL";
    }else{
      pill.classList.add("slbQcPill--pending");
      pill.textContent = "PENDING";
    }
    if(detail){
      det.style.display = "block";
      det.textContent = String(detail);
    }else{
      det.style.display = "none";
      det.textContent = "";
    }
  }

  function withTimeout(promise, ms, label){
    return new Promise(function(resolve, reject){
      var done = false;
      var t = setTimeout(function(){
        if(done) return;
        done = true;
        reject(new Error((label||"Timeout") + " (" + ms + "ms)"));
      }, ms);
      promise.then(function(v){
        if(done) return;
        done = true;
        clearTimeout(t);
        resolve(v);
      }).catch(function(e){
        if(done) return;
        done = true;
        clearTimeout(t);
        reject(e);
      });
    });
  }

  async function fetchText(url){
    // Use omit credentials to avoid cross-origin credential quirks (Shopify CDN)
    var res = await fetch(url, { cache: "no-store", credentials: "omit", mode: "cors" });
    if(!res.ok) throw new Error("Fetch failed: " + res.status + " " + res.statusText);
    return await res.text();
  }

  function parseBuildHeader(code){
    // Scan top few KB (robust against long headers / CDN wrappers)
    var head = String(code||"").slice(0, 65536);
    // Primary: comment header
    var m = head.match(/Build-Version:\s*([^\s*]+)/i);
    if(m && m[1]) return String(m[1]||"").trim();
    // Fallback: injected JS build-tag vars (survives minification/comment stripping)
    m = head.match(/__SLB_[A-Z0-9_]+_BUILD_TAG__\s*=\s*["']([^"']+)["']/);
    if(m && m[1]) return String(m[1]||"").trim();
    return "";
  }

  function compileOnly(code){
    // Syntax check without executing module code
    // Wrap in function body; avoid "use strict" duplication issues.
    // Note: If code uses top-level "return", it'll fail (it shouldn't).
    // Also, extremely large bodies can be heavy; keep list small.
    new Function(code);
  }

  function getAdminFlag(){
    return safeGet(function(){ return (sessionStorage.getItem("tyw_isAdmin")==="1"); }, false);
  }

  async function run(){
    var statusEl = $("slbQcStatus");
    if(statusEl) statusEl.textContent = "Running...";
    var list = $("slbQcList");
    list.innerHTML = "";

    var report = [];
    var tests = [];

    var expectedBuild = (window.__SLB_QC_EXPECT_BUILD__ || window.__SLB_BUILD_TAG__ || "").trim();

    tests.push({
      name: "Gate: admin session",
      run: async function(){
        var ok = getAdminFlag();
        if(!ok) throw new Error("Not admin (sessionStorage.tyw_isAdmin != 1).");
        return "Admin flag detected.";
      }
    });

    tests.push({
      name: "Build tag available",
      run: async function(){
        var bt = (window.__SLB_BUILD_TAG__ || expectedBuild || "").trim();
        if(!bt) throw new Error("Missing build tag.");
        if(expectedBuild && bt !== expectedBuild) return "Build tag present: " + bt + " (expected " + expectedBuild + ")";
        return "Build tag: " + bt;
      }
    });

    tests.push({
      name: "Core globals loaded",
      run: async function(){
        if(!window.SLB) throw new Error("window.SLB missing.");
        if(!window.SLB.__generatedLoaded) throw new Error("SLB generated bundle not loaded.");
        if(!window.SLB_APP || typeof window.SLB_APP.rpc !== "function") throw new Error("window.SLB_APP.rpc missing.");
        return "SLB + SLB_APP.rpc OK.";
      }
    });

    tests.push({
      name: "Helper functions loaded",
      run: async function(){
        var miss = [];
        if(!window.SLBH) miss.push("SLBH");
        if(typeof window.qs!=="function") miss.push("qs");
        if(typeof window.el!=="function") miss.push("el");
        if(typeof window.on!=="function") miss.push("on");
        if(typeof window.setText!=="function") miss.push("setText");
        if(miss.length) throw new Error("Missing: " + miss.join(", "));
        return "Helpers OK.";
      }
    });

    tests.push({
      name: "Backend ping (public)",
      run: async function(){
        var rpc = window.SLB_APP && window.SLB_APP.rpc;
        if(typeof rpc!=="function") throw new Error("rpc not ready.");
        var t0 = Date.now();
        var out = await withTimeout(Promise.resolve(rpc("ping", {})), 8000, "Ping timeout");
        var dt = Date.now() - t0;
        var build = safeGet(function(){ return out && out.build; }, "");
        var st = safeGet(function(){ return out && out.serverTime; }, "");
        if(!st) throw new Error("Ping returned no serverTime.");
        return "OK in " + dt + "ms. serverTime=" + st + (build ? (" build=" + build) : "");
      }
    });

    tests.push({
      name: "Asset Build-Version headers match",
      run: async function(){
        var urls = window.__SLB_QC_ASSET_URLS__ || {};
        var keys = Object.keys(urls);
        if(!keys.length) throw new Error("No asset list.");
        var expectedBuild = (window.__SLB_QC_EXPECT_BUILD__ || window.__SLB_BUILD_TAG__ || "").trim();
        var mism = [];
        var seen = {};
        var missing = [];
        for(var i=0;i<keys.length;i++){
          var k = keys[i];
          var url = urls[k];
          var code = await withTimeout(fetchText(url), 12000, "Fetch " + k);
          var bv = parseBuildHeader(code);
          if(!bv){
            var sniff = String(code||"").slice(0, 160).replace(/\s+/g," ").trim();
            missing.push(k + ": (missing Build-Version header) first160=" + JSON.stringify(sniff));
            continue;
          }
          seen[bv] = (seen[bv]||0) + 1;
          // Only enforce "expected" if it is explicitly set to something real (not UNKNOWN)
          if(expectedBuild && String(expectedBuild).toUpperCase() !== "UNKNOWN" && bv !== expectedBuild){
            mism.push(k + ": " + bv + " (expected " + expectedBuild + ")");
          }
        }
        if(missing.length) throw new Error("Mismatch:\n" + missing.join("\n"));
        if(mism.length) throw new Error("Mismatch:\n" + mism.join("\n"));
        var uniq = Object.keys(seen);
        if(uniq.length > 1){
          // Assets disagree with each other
          var detail = [];
          for(var u=0;u<uniq.length;u++){ detail.push(uniq[u] + " x" + seen[uniq[u]]); }
          throw new Error("Mismatch:\nMultiple Build-Version values: " + detail.join(", "));
        }
        var val = uniq[0] || "(none)";
        // If expectedBuild was UNKNOWN/empty, just report the unified value
        return "All checked assets match " + val;
      }
    });
    tests.push({
      name: "Asset syntax compile (no execute)",
      run: async function(){
        var urls = window.__SLB_QC_ASSET_URLS__ || {};
        // Only compile the deferred slices (avoid re-compiling the huge generated bundle)
        var compileList = ["slb.chat.js","slb.diary.js","slb.ops.js","slb.letters.js"];
        var bad = [];
        for(var i=0;i<compileList.length;i++){
          var k = compileList[i];
          var url = urls[k];
          if(!url) continue;
          var code = await withTimeout(fetchText(url), 12000, "Fetch " + k);
          try{
            compileOnly(code);
          }catch(e){
            bad.push(k + ": " + (e && e.message ? e.message : String(e)));
          }
        }
        if(bad.length) throw new Error("Syntax fail:\n" + bad.join("\n"));
        return "Compile OK (" + compileList.join(", ") + ")";
      }
    });

    // Render rows first
    var rows = tests.map(function(t){
      var row = mkRow(t);
      list.appendChild(row);
      return row;
    });

    // Gate UI if not admin
    var gate = $("slbQcGate");
    var isAdm = getAdminFlag();
    if(!isAdm){
      gate.style.display = "block";
      gate.textContent = "Admin only. Open SLB as admin first (so sessionStorage.tyw_isAdmin=1), then reload.";
      // Still show minimal diagnostics
    }else{
      gate.style.display = "none";
    }

    // Run tests sequentially
    for(var ti=0; ti<tests.length; ti++){
      var t = tests[ti];
      var row = rows[ti];
      setRow(row, "PENDING", "");
      try{
        var detail = await t.run();
        setRow(row, "PASS", detail);
        report.push("✅ " + t.name + "\n" + String(detail||""));
      }catch(e){
        var msg = (e && e.message) ? e.message : String(e);
        setRow(row, "FAIL", msg);
        report.push("❌ " + t.name + "\n" + msg);
        // If admin gate failed, stop early to avoid noisy errors
        if(ti===0) break;
      }
    }

    if(statusEl) statusEl.textContent = "Done.";
    window.__SLB_QC_REPORT__ = report.join("\n\n");
  }

  function wire(){
    setText("slbQcBuildTag", (window.__SLB_BUILD_TAG__ || window.__SLB_QC_EXPECT_BUILD__ || "").trim());
    setText("slbQcNow", nowIso());

    var runBtn = $("slbQcRun");
    var copyBtn = $("slbQcCopy");
    var copyLogsBtn = $("slbQcCopyLogs");
    var bundleBtn = $("slbQcCopyBundle");
    var logsBox = $("slbQcLogsBox");
    if(runBtn) runBtn.addEventListener("click", function(){ run(); });
    if(copyBtn) copyBtn.addEventListener("click", async function(){
      var txt = (window.__SLB_QC_REPORT__ || "").trim();
      if(!txt) txt = "No report yet. Click Run QC first.";
      try{
        await navigator.clipboard.writeText(txt);
        var st = $("slbQcStatus");
        if(st) st.textContent = "Copied.";
        setTimeout(function(){ if(st) st.textContent=""; }, 1200);
      }catch(e){
        // fallback: alert
        alert(txt);
      }
    });

    if(copyLogsBtn) copyLogsBtn.addEventListener("click", async function(){
      try{
        var logs = [];
        try{
          if(window.SLB && window.SLB.log && typeof window.SLB.log.dump === "function"){
            logs = window.SLB.log.dump() || [];
          }
        }catch(_e){}
        var payload = JSON.stringify(logs, null, 2);
        if(logsBox){
          logsBox.style.display = "block";
          logsBox.textContent = payload || "";
        }
        if(navigator && navigator.clipboard && navigator.clipboard.writeText){
          await navigator.clipboard.writeText(payload || "");
          setText("slbQcStatus", "Copied logs (" + (logs?logs.length:0) + ")");
        }else{
          setText("slbQcStatus", "Logs ready (" + (logs?logs.length:0) + ") — clipboard not available");
        }
      }catch(e){
        setText("slbQcStatus", "Copy logs failed");
      }
    });
    if(bundleBtn) bundleBtn.addEventListener("click", async function(){
      var txt = "";
      try{
        var bundle = {
          v: 1,
          ts: nowIso(),
          build: String((window.__SLB_BUILD_TAG__ || window.__SLB_QC_EXPECT_BUILD__ || window.__SLB_QC_BUILD_TAG__ || "")).trim(),
          page: String(location.href || ""),
          online: (navigator.onLine !== false),
          ua: String(navigator.userAgent || ""),
          qc_report: String((window.__SLB_QC_REPORT__ || "")).trim(),
          last_error: String((window.__slbLastErrorText || "")).trim(),
          logs: []
        };
        try{
          if(window.SLB && SLB.log && typeof SLB.log.dump === "function"){
            var arr = SLB.log.dump() || [];
            if(arr && arr.length > 50) arr = arr.slice(arr.length - 50);
            bundle.logs = arr || [];
          }
        }catch(e){}
        txt = "SLB_REPORT_BUNDLE v1\n" + JSON.stringify(bundle, null, 2);
        await navigator.clipboard.writeText(txt);
        setText("slbQcStatus", "Bundle copied.");
        setTimeout(function(){ setText("slbQcStatus",""); }, 1200);
      }catch(e){
        if(txt) alert(txt);
        else alert("Bundle copy failed.");
      }
    });


    // Auto-run if admin
    if(getAdminFlag()){
      run();
    }else{
      // Still run minimal build/core checks when not admin
      // but only after user hits Run QC (avoid confusion).
    }
  }

  document.addEventListener("DOMContentLoaded", wire);
})();
